import React from 'react';
export function BonusSection() {
  const scrollToOffer = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    image: 'https://cdn.magicpatterns.com/uploads/s26LrkmiL6P94bRi93Kwqw/bono_1.png',
    title: 'Recetario Express de Snacks para Air Fryer',
    description: 'Ideas rápidas para preparar comidas y picoteos deliciosos en minutos.'
  }, {
    id: 2,
    image: 'https://cdn.magicpatterns.com/uploads/pAdj646auHxdwGTHgKvSwt/bono_2.png',
    title: 'Guía Completa de Tiempos y Temperaturas para Air Fryer',
    description: 'Para que nunca más tengas que adivinar cuánto cocinar cada alimento.'
  }, {
    id: 3,
    image: 'https://cdn.magicpatterns.com/uploads/wj5ZvyKzb1DA57psBVDExB/bono_3.png',
    title: 'Recetario Especial de Postres en Air Fryer',
    description: 'Recetas dulces fáciles que sorprenden a todos.'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/8nGYXgcSp9VcE3pa9Rwq8q/bono_4.png',
    title: 'Tabla de Conversiones y Trucos para Air Fryer',
    description: 'Pequeños secretos que hacen una gran diferencia en el resultado de tus recetas.'
  }];
  return <section className="py-20 px-4 bg-dark-light" data-id="element-24">
      <div className="max-w-6xl mx-auto" data-id="element-25">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-white" data-id="element-26">
          Además vas a recibir bonos exclusivos
        </h2>
        <p className="text-xl text-center text-gray-400 mb-16" data-id="element-27">
          Que aumentan aún más el valor de este pack
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-28">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col sm:flex-row gap-6 items-center sm:items-start relative overflow-hidden group" data-id="element-29">
              <div className="absolute top-0 right-0 bg-primary text-dark font-bold px-4 py-1 rounded-bl-xl z-10" data-id="element-30">
                🎁 GRATIS POR HOY
              </div>

              <div className="w-1/2 sm:w-1/3 flex-shrink-0 cursor-pointer" onClick={scrollToOffer} data-id="element-31">
                <img src={bonus.image} alt={bonus.title} className="w-full rounded-lg shadow-lg group-hover:scale-105 transition-transform duration-300" data-id="element-32" />
              </div>

              <div className="flex-1 text-center sm:text-left pt-4 sm:pt-0" data-id="element-33">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-34">
                  {bonus.title}
                </h3>
                <p className="text-gray-300" data-id="element-35">{bonus.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}